// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1dgCI","footer":"ModalFilter_footer__1o30w"};